import { useState } from "react";
import { Box, Button, Input, Typography, Card, Snackbar, Stack } from "@mui/joy";
import { Report } from '@mui/icons-material';

import LoadingSpinnerComponent from '../components/LoadingSpinnerComponent';

import logo from '../resources/logo.svg'
import footer_appinion from '../resources/logo.svg'

const networking = require('../Networking/AuthenticationAPI');

const ForgotPassword = () => {
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [error, setError] = useState('');
    const [showError, setShowError] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        setLoading(true);

        try {
            networking.sendRecoveryEmail(email).then((data: any) => {
                setLoading(false);
                setShowSuccess(true);
            }).catch((error: Error) => {
                setError(error.message);
                setShowError(true);
                setLoading(false);
            });

        } catch (error: any) {
            setError(error.message);
            setShowError(true);
            setLoading(false);
        }

    };

    return (
        <>
            {showError &&
                <Snackbar
                    variant="soft"
                    color="danger"
                    open={showError}
                    onClose={() => setShowError(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Report />}
                    endDecorator={
                        <Button
                            onClick={() => setShowError(false)}
                            size="sm"
                            variant="soft"
                            color="danger"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    {error}
                </Snackbar>
            }
            {showSuccess &&
                <Snackbar
                    variant="soft"
                    color="success"
                    open={showSuccess}
                    onClose={() => setShowSuccess(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    startDecorator={<Report />}
                    endDecorator={
                        <Button
                            onClick={() => setShowSuccess(false)}
                            size="sm"
                            variant="soft"
                            color="success"
                        >
                            Dismiss
                        </Button>
                    }
                >
                    Email sent. 🚀
                </Snackbar>
            }
            <div className='container-fluid bg-cloudie p-5'>
                <div className='text-center'>
                    <a
                        href='/'>
                        <img
                            src={logo}
                            height={40 + 'px'}
                            alt='Appinion logo' />
                    </a>
                </div>
                <div className='mt-4 text-center'>
                    <Typography
                        level="title-lg"
                        sx={{
                            fontWeight: 'bold',
                            color: '#313131',
                            marginBottom: 1
                        }}>
                        Forgot password ?
                    </Typography>
                    <Typography
                        level="body-sm"
                        sx={{
                            color: '#313131',
                            marginBottom: 1,
                        }}>
                        Don't worry, we got you covered. Enter your email and we'll send you a link to reset your password.
                    </Typography>
                </div>
                <Card
                    sx={{
                        mx: 'auto', // margin left & right
                        my: 4, // margin top & bottom
                        py: 5, // padding top & bottom
                        px: 5, // padding left & right
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        borderRadius: 'sm',
                        boxShadow: 'md',
                        maxWidth: 600
                    }}
                    variant="outlined"
                >
                    {loading ?
                        <LoadingSpinnerComponent />
                        :
                        <form
                            onSubmit={handleSubmit}>
                            <Stack
                                spacing={4}>
                                <Box sx={{ mb: 2 }}>
                                    <Input
                                        type="email"
                                        placeholder="Enter your email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        fullWidth
                                    />
                                </Box>
                                <Button
                                    type="submit"
                                    fullWidth
                                    color="primary">
                                    Send Recovery Link
                                </Button>
                            </Stack>
                        </form>
                    }
                </Card>
                <div className="mt-4 text-center">
                    <Typography
                        level="body-sm"
                        color="neutral"
                        component="h1">
                        <a href='/authenticate'>
                            <span
                                className='underlined'>Back to sign in</span>
                        </a>
                    </Typography>
                </div>
            </div>
            <footer className='p-3 text-center'>
                <p className='legend light-iron'>© Appinion 2026. All rights reserved</p>
                <img className='ms-3' src={footer_appinion} alt="logo" style={{ height: 16 + 'px' }}></img>
                <ul className='navbar-nav ms-auto'>
                    <li className='nav-item'>
                    </li>
                </ul>
            </footer>
        </>
    );
};

export default ForgotPassword;